import actions from '@devices/settings/device_settings/actions.js';
import app from '@devices/settings/device_settings/app.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellyix3',
	friendly_name: 'I3',
	family: 'inputs_reader',
	isPM: false,
	modes: {
		inputs_reader: {
			channels: 3,
			notifications: ['offline', 'device_problem'],
			settings: [
				actions,
				{
					title: 'networks',
					components: [
						{ title: 'wifi_mode_client', component: 'wifi_mode_client' },
						{ title: 'wifi_client_backup', component: 'wifi_client_backup' },
						{ title: 'wifi_mode_ap', component: 'wifi_mode_ap' },
						{ title: 'wifi_ap_roaming', component: 'wifi_ap_roaming' },
						{ title: 'restrict_login', component: 'restrict_login' },
						{ title: 'cloud', component: 'cloud' },
					],
				},
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'button_type', component: 'button_type_inputs_reader' },
						{ title: 'long_push', component: 'long_push_inputs' },
						{ title: 'multi_push', component: 'multi_push' },
						{ title: 'led_status_disable', component: 'led_status_disable' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'channel_name', component: 'channel_name' },
						{ title: 'device_name', component: 'device_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
